<div class="install-prompt" *ngIf="showInstallPrompt && !instalationRejected">
    <h2>{{ labels.title | translate }}</h2>
    <p>{{ labels.subtitle | translate }}</p>
    <div class="buttons-wrapper">
        <button mat-stroked-button (click)="dismiss()">
            {{ labels.cancel | translate }}
        </button>
        <button mat-raised-button color="primary" (click)="install()">{{ labels.install | translate }}</button>
    </div>
</div>
